<template>
    <div class="page-block__item-wrapper">
        <div class="page-block__item">
            <div class="page-block__item-content">
                <div class="layout">
                    <div class="layout__item u-1/4-desk">
                        <span class="page-block__item-content-title">
                            {{ trans('ssl.status') }}
                        </span>
                    </div>
                    <div class="layout__item u-3/4-desk">
                        <span class="label label--unprotected">
                            <img src="../assets/feather-icons/lock-status.svg" class="label__icon" />
                            {{ trans('ssl.unprotected') }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {};
</script>
